"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const react_helmet_1 = __importDefault(require("react-helmet"));
const cookies_1 = require("@App/helpers/cookies");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const PublicSearchPopup_1 = __importDefault(require("@Components/Popups/PublicSearchPopup"));
const cookies_2 = require("@Const/cookies");
const PublicSearchByWorkTab_1 = __importDefault(require("@Scenes/PublicSearchScene/PublicSearchByWorkTab"));
const PublicSearchByWriterTab_1 = __importDefault(require("@Scenes/PublicSearchScene/PublicSearchByWriterTab"));
const PublicSearchByPublisherTab_1 = __importDefault(require("@Scenes/PublicSearchScene/PublicSearchByPublisherTab"));
const contexts_1 = require("@App/contexts");
const TabsWrapperComponent_1 = __importDefault(require("@Components/TabsWrapperComponent"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const PublicSearchScene = () => {
    const [isPopupOpen, setIsPopupOpen] = (0, react_1.useState)(!(0, cookies_1.getCookie)(cookies_2.PUBLIC_SEARCH_COOKIE));
    const { uiStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    (0, react_1.useEffect)(() => {
        uiStore.setOnLoginPage(false);
        (0, analytics_utils_1.analyticsSendPage)('public_search');
    }, []);
    const publicSearchTabs = [
        {
            tabName: 'Work',
            tabComponent: react_1.default.createElement(PublicSearchByWorkTab_1.default, { key: "Work" }),
        },
        {
            tabName: 'Writer',
            tabComponent: react_1.default.createElement(PublicSearchByWriterTab_1.default, { key: "Writer" }),
        },
        {
            tabName: 'Publisher',
            tabComponent: react_1.default.createElement(PublicSearchByPublisherTab_1.default, { key: "Publisher" }),
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Public Search' }),
        react_1.default.createElement("main", { className: "public-search-scene" },
            react_1.default.createElement("div", { className: "global-container" },
                react_1.default.createElement("div", { className: "search-header" },
                    react_1.default.createElement("h1", null, "The MLC Public Work Search")),
                react_1.default.createElement("p", { className: "starting-paragraph" }, "The accuracy and completeness of The MLC's data is determined solely by our Members."),
                react_1.default.createElement("p", { className: "ending-paragraph" }, "It is not an authoritative source for recording information."),
                react_1.default.createElement("p", null,
                    "Please",
                    ' ',
                    react_1.default.createElement("a", { href: "https://themlc.com/faqs/categories/music-industry-terminology", target: "_blank", rel: "noreferrer" }, "click here"),
                    ' ',
                    "for more information about the terms used in the database."),
                react_1.default.createElement("p", { className: "ending-paragraph" },
                    "Please review the Musical Works Database",
                    react_1.default.createElement("a", { href: "https://www.themlc.com/musicalworksdatabasetermsuse", target: "_blank", rel: "noreferrer" },
                        ' ',
                        "Terms of Use")),
                react_1.default.createElement("div", { className: "public-search-container" },
                    react_1.default.createElement(TabsWrapperComponent_1.default, { tabs: publicSearchTabs, defaultTab: publicSearchTabs[0] })),
                react_1.default.createElement(ModalPortal_1.default, { isOpen: isPopupOpen, onClose: () => setIsPopupOpen(false) },
                    react_1.default.createElement(Popup_1.default, { showClose: false, onClose: () => setIsPopupOpen(false) },
                        react_1.default.createElement(PublicSearchPopup_1.default, { closePopup: () => setIsPopupOpen(false) })))))));
};
exports.default = PublicSearchScene;
